import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import axios from '../../axios/axiosconf';

function Facturacion() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    
    // Estados del formulario
    const [fecha, setFecha] = useState(new Date().toISOString().split('T')[0]);
    const [vencimiento, setVencimiento] = useState(new Date().toISOString().split('T')[0]);
    const [profesional, setProfesional] = useState('');
    const [sede, setSede] = useState('');
    const [prefijo, setPrefijo] = useState('');
    const [numeroFactura, setNumeroFactura] = useState('');
    const [metodoPago, setMetodoPago] = useState('10');
    
    // Estados para datos de API
    const [profesionales, setProfesionales] = useState([]);
    const [parametrosFev, setParametrosFev] = useState([]);
    
    // Estados del paciente
    const [pacienteId, setPacienteId] = useState('');
    const [nombrePaciente, setNombrePaciente] = useState('');
    const [tipoPaciente, setTipoPaciente] = useState('CC');
    const [documentoPaciente, setDocumentoPaciente] = useState('');
    
    // Estados de productos
    const [productos, setProductos] = useState([]);
    const [productoSeleccionado, setProductoSeleccionado] = useState('');
    const [totalBruto, setTotalBruto] = useState(0);
    const [totalPagar, setTotalPagar] = useState(0);
    
    // Estados para lista de precios
    const [listaPrecios, setListaPrecios] = useState([]);
    const [clasificacionFiltro, setClasificacionFiltro] = useState('');
    const [especialidades, setEspecialidades] = useState([]);
    const [impuestos, setImpuestos] = useState([]);
    
    const [observaciones, setObservaciones] = useState('');
    const [showModalPaciente, setShowModalPaciente] = useState(false);
    const [pacientes, setPacientes] = useState([]);
    const [busquedaPaciente, setBusquedaPaciente] = useState('');
    const [paginaActual, setPaginaActual] = useState(1);
    const pacientesPorPagina = 10;

    // Datos de ejemplo para sedes
    const sedes = [
        { id: 1, nombre_sede: 'Sede Principal' },
        { id: 2, nombre_sede: 'Sede Norte' }
    ];



    useEffect(() => {
        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        // Cargar cliente
        axios.get('/get-client?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar profesionales
        axios.get('/usuarios?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setProfesionales(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar parámetros FEV
        axios.get('/parametros-fev?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setParametrosFev(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar pacientes
        axios.get('/pacientes?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setPacientes(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar especialidades
        axios.get('/especialidades-referencia?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setEspecialidades(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar lista de precios
        axios.get('/lista-precios?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setListaPrecios(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar impuestos (tabla maestra - sin filtro por client_id)
        axios.get('/administrador-impuestos', config)
            .then(response => {
                if (response.status === 200) {
                    setImpuestos(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });
    }, []);

    const handlePrefijoChange = (e) => {
        const selectedPrefijo = getPrefijosFiltrados().find(p => p.id == e.target.value);
        setPrefijo(e.target.value);
        if (selectedPrefijo) {
            setNumeroFactura(selectedPrefijo.numero_factura);
        }
    };

    const getPrefijosFiltrados = () => {
        return parametrosFev.filter(param => 
            param.tipo === 'Factura Electronica' && 
            param.users_id == profesional &&
            param.estado == 1
        );
    };

    const getListaPreciosFiltrada = () => {
        console.log('Filtro aplicado:', clasificacionFiltro);
        console.log('Lista precios completa:', listaPrecios);
        
        if (!clasificacionFiltro) {
            console.log('Sin filtro, devolviendo todos');
            return listaPrecios;
        }
        
        const filtrados = listaPrecios.filter(item => {
            console.log(`Comparando: ${item.clasificacion} === ${clasificacionFiltro}`);
            return item.clasificacion === clasificacionFiltro;
        });
        
        console.log('Resultados filtrados:', filtrados);
        return filtrados;
    };

    const agregarServicio = () => {
        const servicio = listaPrecios.find(s => s.id == productoSeleccionado);
        if (servicio) {
            const nuevoProducto = {
                id: Date.now(),
                id_listadeprecios: servicio.id,
                codigo: servicio.codigo,
                descripcion: servicio.nombre,
                cantidad: 1,
                precio: parseFloat(servicio.precio),
                porcentaje: 0,
                impuesto: 0,
                total: parseFloat(servicio.precio)
            };
            setProductos([...productos, nuevoProducto]);
            calcularTotales([...productos, nuevoProducto]);
            setProductoSeleccionado('');
        }
    };

    const eliminarProducto = (id) => {
        const nuevosProductos = productos.filter(p => p.id !== id);
        setProductos(nuevosProductos);
        calcularTotales(nuevosProductos);
    };

    const actualizarProducto = (id, campo, valor) => {
        const nuevosProductos = productos.map(p => {
            if (p.id === id) {
                const productoActualizado = { ...p, [campo]: parseFloat(valor) || 0 };
                
                // Recalcular total del producto
                const descuento = (productoActualizado.precio * productoActualizado.cantidad) * (productoActualizado.porcentaje / 100);
                const totalBase = (productoActualizado.precio * productoActualizado.cantidad) - descuento;
                const totalConImpuesto = totalBase + (totalBase * (productoActualizado.impuesto / 100));
                productoActualizado.total = totalConImpuesto;
                
                return productoActualizado;
            }
            return p;
        });
        setProductos(nuevosProductos);
        calcularTotales(nuevosProductos);
    };

    const calcularTotales = (productosArray) => {
        let bruto = 0;
        let pagar = 0;

        productosArray.forEach(producto => {
            bruto += (producto.precio * producto.cantidad);
            pagar += producto.total;
        });

        setTotalBruto(bruto);
        setTotalPagar(pagar);
    };

    const getPacientesFiltrados = () => {
        if (!busquedaPaciente) return pacientes;
        
        return pacientes.filter(paciente => {
            const nombreCompleto = `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim().toLowerCase();
            const documento = paciente.numero_documento || '';
            const busqueda = busquedaPaciente.toLowerCase();
            
            return nombreCompleto.includes(busqueda) || documento.includes(busqueda);
        });
    };

    const getPacientesPaginados = () => {
        const pacientesFiltrados = getPacientesFiltrados();
        const inicio = (paginaActual - 1) * pacientesPorPagina;
        const fin = inicio + pacientesPorPagina;
        return pacientesFiltrados.slice(inicio, fin);
    };

    const getTotalPaginas = () => {
        return Math.ceil(getPacientesFiltrados().length / pacientesPorPagina);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!pacienteId) {
            alert('Por favor seleccione un paciente');
            return;
        }
        
        if (productos.length === 0) {
            alert('Debe agregar al menos un servicio');
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token,
                'Content-Type': 'application/json'
            }
        };

        const facturaData = {
            parametrosfev_id: parseInt(prefijo),
            users_id: parseInt(profesional),
            paciente_id: parseInt(pacienteId),
            fecha_emision: fecha,
            fecha_vence: vencimiento,
            numero_factura: numeroFactura,
            forma_pago: metodoPago,
            valor_bruto: parseFloat(totalBruto),
            valor_total: parseFloat(totalPagar),
            observaciones: observaciones || '',
            detalle: productos.map(producto => ({
                id_listadeprecios: parseInt(producto.id_listadeprecios),
                cantidad: parseInt(producto.cantidad),
                precio_unitario: parseFloat(producto.precio),
                porcentaje: parseFloat(producto.porcentaje),
                impuesto: parseFloat(producto.impuesto),
                total: parseFloat(producto.total)
            }))
        };

        console.log('Datos a enviar:', facturaData);

        try {
            const response = await axios.post('/factura', facturaData, config);
            if (response.status === 200 || response.status === 201) {
                alert('Factura guardada exitosamente');
                // Limpiar formulario
                setProductos([]);
                setPacienteId('');
                setNombrePaciente('');
                setDocumentoPaciente('');
                setObservaciones('');
                setTotalBruto(0);
                setTotalPagar(0);
            }
        } catch (error) {
            console.error('Error completo:', error);
            console.error('Response data:', error.response?.data);
            console.error('Response status:', error.response?.status);
            alert('Error al guardar la factura: ' + (error.response?.data?.message || error.message));
        }
    };

    if (loggedIn) {
        return (
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="billing" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Registrar FEV</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            
                            <div className="card card-info card-outline">
                                <div className="card card-info-outline">
                                    <div className="card-header">
                                        <h5><b>Información de la Factura</b></h5>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Fecha del Documento *</label>
                                                        <input 
                                                            type="date" 
                                                            className="form-control" 
                                                            value={fecha}
                                                            onChange={(e) => setFecha(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Vencimiento *</label>
                                                        <input 
                                                            type="date" 
                                                            className="form-control" 
                                                            value={vencimiento}
                                                            onChange={(e) => setVencimiento(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Profesional *</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={profesional}
                                                            onChange={(e) => setProfesional(e.target.value)}
                                                            required
                                                        >
                                                            <option value="">Seleccionar...</option>
                                                            {profesionales.map(prof => (
                                                                <option key={prof.id} value={prof.id}>{prof.name} {prof.lastname}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Sede *</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={sede}
                                                            onChange={(e) => setSede(e.target.value)}
                                                            required
                                                        >
                                                            <option value="">Seleccionar...</option>
                                                            {sedes.map(s => (
                                                                <option key={s.id} value={s.id}>{s.nombre_sede}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Prefijo *</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={prefijo}
                                                            onChange={handlePrefijoChange}
                                                            required
                                                        >
                                                            <option value="">Seleccionar...</option>
                                                            {getPrefijosFiltrados().map(p => (
                                                                <option key={p.id} value={p.id}>{p.prefijo}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>N° Factura *</label>
                                                        <input 
                                                            type="text" 
                                                            className="form-control" 
                                                            value={numeroFactura}
                                                            readOnly
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Método de Pago *</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={metodoPago}
                                                            onChange={(e) => setMetodoPago(e.target.value)}
                                                            required
                                                        >
                                                            <option value="10">Efectivo</option>
                                                            <option value="42">Consignación bancaria</option>
                                                            <option value="1">Instrumento no definido</option>
                                                            <option value="20">Cheque</option>
                                                            <option value="30">Transferencia Crédito</option>
                                                            <option value="31">Transferencia Débito</option>
                                                            <option value="45">Transferencia Crédito Bancario</option>
                                                            <option value="47">Transferencia Débito Bancaria</option>
                                                            <option value="48">Tarjeta Crédito</option>
                                                            <option value="49">Tarjeta Débito</option>
                                                            <option value="ZZZ">Acuerdo mutuo</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr />

                                            <h5><b>Información del Paciente</b></h5>
                                            
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Nombre *</label>
                                                        <input 
                                                            type="text" 
                                                            className="form-control" 
                                                            value={nombrePaciente}
                                                            readOnly
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Tipo *</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={tipoPaciente}
                                                            readOnly
                                                            required
                                                        >
                                                            <option value="CC">CC</option>
                                                            <option value="CE">CE</option>
                                                            <option value="PA">PA</option>
                                                            <option value="PE">PE</option>
                                                            <option value="RC">RC</option>
                                                            <option value="TI">TI</option>
                                                            <option value="NIT">NIT</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>N° Documento *</label>
                                                        <input 
                                                            type="text" 
                                                            className="form-control" 
                                                            value={documentoPaciente}
                                                            readOnly
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-1">
                                                    <div className="form-group">
                                                        <button 
                                                            type="button" 
                                                            className="btn btn-info"
                                                            style={{marginTop: '32px'}}
                                                            onClick={() => setShowModalPaciente(true)}
                                                        >
                                                            <i className="fas fa-search"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr />

                                            <div className="form-group">
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <label>Clasificación</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={clasificacionFiltro}
                                                            onChange={(e) => setClasificacionFiltro(e.target.value)}
                                                        >
                                                            <option value="">Todas</option>
                                                            {especialidades.map(esp => (
                                                                <option key={esp.id} value={esp.nombre}>{esp.nombre}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <label>Selecciona el Servicio a Facturar</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={productoSeleccionado}
                                                            onChange={(e) => setProductoSeleccionado(e.target.value)}
                                                        >
                                                            <option value="">Seleccionar...</option>
                                                            {getListaPreciosFiltrada().map(servicio => (
                                                                <option key={servicio.id} value={servicio.id}>
                                                                    {servicio.codigo} - {servicio.nombre}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <button 
                                                    type="button" 
                                                    className="btn btn-info mt-2"
                                                    onClick={agregarServicio}
                                                >
                                                    Agregar Servicio
                                                </button>
                                            </div>

                                            <hr />

                                            {/* Tabla de productos */}
                                            <div className="card-body table-responsive p-0">
                                                <table className="table table-bordered table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th style={{width: '10%'}}>Código</th>
                                                            <th style={{width: '25%'}}>Descripción</th>
                                                            <th style={{width: '8%'}}>Cant.</th>
                                                            <th style={{width: '12%'}}>Precio</th>
                                                            <th style={{width: '8%'}}>Desc %</th>
                                                            <th style={{width: '15%'}}>Impuesto</th>
                                                            <th style={{width: '12%'}}>Total</th>
                                                            <th style={{width: '10%'}}>Acción</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {productos.map(producto => (
                                                            <tr key={producto.id}>
                                                                <td>
                                                                    <input 
                                                                        type="text" 
                                                                        className="form-control form-control-sm" 
                                                                        value={producto.codigo}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'codigo', e.target.value)}
                                                                    />
                                                                </td>
                                                                <td style={{fontSize: '14px', padding: '8px'}}>{producto.descripcion}</td>
                                                                <td>
                                                                    <input 
                                                                        type="number" 
                                                                        className="form-control form-control-sm" 
                                                                        value={producto.cantidad}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'cantidad', e.target.value)}
                                                                        min="1"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input 
                                                                        type="number" 
                                                                        className="form-control form-control-sm" 
                                                                        value={producto.precio}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'precio', e.target.value)}
                                                                        step="0.01"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input 
                                                                        type="number" 
                                                                        className="form-control form-control-sm" 
                                                                        value={producto.porcentaje}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'porcentaje', e.target.value)}
                                                                        min="0"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <select 
                                                                        className="form-control form-control-sm" 
                                                                        value={producto.impuesto}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'impuesto', e.target.value)}
                                                                    >
                                                                        <option value="0">0</option>
                                                                        {impuestos.map(imp => (
                                                                            <option key={imp.id} value={imp.impuesto}>{imp.nombre+' '+imp.impuesto+'%'}</option>
                                                                        ))}
                                                                    </select>
                                                                </td>
                                                                <td>
                                                                    <input 
                                                                        type="number" 
                                                                        className="form-control form-control-sm" 
                                                                        value={parseFloat(producto.total || 0).toFixed(2)}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                                <td style={{textAlign: 'center'}}>
                                                                    <button 
                                                                        type="button" 
                                                                        className="btn btn-danger btn-sm"
                                                                        onClick={() => eliminarProducto(producto.id)}
                                                                    >
                                                                        ×
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <td colSpan="6" className="text-right"><strong>Total Bruto:</strong></td>
                                                            <td colSpan="2">
                                                                <input 
                                                                    type="text" 
                                                                    className="form-control" 
                                                                    value={parseFloat(totalBruto || 0).toFixed(2)}
                                                                    readOnly
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="6" className="text-right"><strong>Total a Pagar:</strong></td>
                                                            <td colSpan="2">
                                                                <input 
                                                                    type="text" 
                                                                    className="form-control" 
                                                                    value={parseFloat(totalPagar || 0).toFixed(2)}
                                                                    readOnly
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>

                                            <hr />

                                            <div className="form-group">
                                                <label>Observaciones</label>
                                                <textarea 
                                                    className="form-control" 
                                                    rows="5"
                                                    value={observaciones}
                                                    onChange={(e) => setObservaciones(e.target.value)}
                                                    placeholder=""
                                                />
                                            </div>

                                            <div className="form-group">
                                                <button type="submit" className="btn btn-info">
                                                    Guardar
                                                </button>
                                            </div>

                                        </form>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </section>
                </div>

                {/* Modal para seleccionar paciente */}
                {showModalPaciente && (
                    <div className="modal fade show" style={{display: 'block'}} tabIndex="-1">
                        <div className="modal-dialog modal-lg modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">Seleccionar Paciente</h4>
                                    <button 
                                        type="button" 
                                        className="close" 
                                        onClick={() => setShowModalPaciente(false)}
                                    >
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                                    <div className="row mb-3">
                                        <div className="col-md-12">
                                            <div className="input-group">
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder="Buscar por nombre o documento..."
                                                    value={busquedaPaciente}
                                                    onChange={(e) => {
                                                        setBusquedaPaciente(e.target.value);
                                                        setPaginaActual(1);
                                                    }}
                                                />
                                                <div className="input-group-append">
                                                    <span className="input-group-text">
                                                        <i className="fas fa-search"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="table-responsive" style={{ maxHeight: '48vh', overflowY: 'auto' }}>
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Nombre</th>
                                                    <th>Tipo</th>
                                                    <th>N° Documento</th>
                                                    <th>Acción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {getPacientesPaginados().map(paciente => {
                                                    const nombreCompleto = `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim();
                                                    return (
                                                        <tr key={paciente.id}>
                                                            <td>{nombreCompleto}</td>
                                                            <td>{paciente.tipo_documento}</td>
                                                            <td>{paciente.numero_documento}</td>
                                                            <td>
                                                                <button 
                                                                    type="button" 
                                                                    className="btn btn-info btn-sm"
                                                                    onClick={() => {
                                                                        setPacienteId(paciente.id);
                                                                        setNombrePaciente(nombreCompleto);
                                                                        setTipoPaciente(paciente.tipo_documento);
                                                                        setDocumentoPaciente(paciente.numero_documento);
                                                                        setShowModalPaciente(false);
                                                                        setBusquedaPaciente('');
                                                                        setPaginaActual(1);
                                                                    }}
                                                                >
                                                                    Seleccionar
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                    
                                    {getTotalPaginas() > 1 && (
                                        <nav>
                                            <ul className="pagination justify-content-center">
                                                <li className={`page-item ${paginaActual === 1 ? 'disabled' : ''}`}>
                                                    <button 
                                                        className="page-link" 
                                                        onClick={() => setPaginaActual(paginaActual - 1)}
                                                        disabled={paginaActual === 1}
                                                    >
                                                        Anterior
                                                    </button>
                                                </li>
                                                {[...Array(getTotalPaginas())].map((_, index) => (
                                                    <li key={index + 1} className={`page-item ${paginaActual === index + 1 ? 'active' : ''}`}>
                                                        <button 
                                                            className="page-link" 
                                                            onClick={() => setPaginaActual(index + 1)}
                                                        >
                                                            {index + 1}
                                                        </button>
                                                    </li>
                                                ))}
                                                <li className={`page-item ${paginaActual === getTotalPaginas() ? 'disabled' : ''}`}>
                                                    <button 
                                                        className="page-link" 
                                                        onClick={() => setPaginaActual(paginaActual + 1)}
                                                        disabled={paginaActual === getTotalPaginas()}
                                                    >
                                                        Siguiente
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button 
                                        type="button" 
                                        className="btn btn-default" 
                                        onClick={() => setShowModalPaciente(false)}
                                    >
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return <Loading />;
}

export default Facturacion;